<template>
<transition name="modal">
  <div class="modalMask postAddressModal">
    <div class="modalWrapper">
      <div class="modalContainer postAddressLayer">
        <div id="wrap">
          <div class="title">
            <h1>주소검색</h1>
            <button class="btn_close" @click.prevent="$emit('showLayer', false)">
              <i class="icon iconClose"></i>
            </button>
          </div>
        </div><!-- ./wrap daum-post-layer-->

        <div class="postAddress">
          <div class="title">
            <h1>배송정보</h1>
            <button class="btn_close" @click.prevent="$emit('showLayer', false)">
              <i class="icon iconClose"></i>
            </button>
          </div>
          <ul class="addressDetail">
            <li>
              <span class="subTitle">받는 분</span>
              <input
                class="inputBox"
                type="text"
                :value="deliveryInformation.receiverName"
                @input="nameFormatInput"
                placeholder="받는 사람"
              />
            </li>
            <li>
              <span class="subTitle">전화번호</span>
              <div class="inputBox">
                <custom-select-box
                  v-model="phoneNumber.provider"
                  :items="serviceProvider"
                  firstItem="010"
                />
                <input
                  class="input"
                  type="text"
                  maxlength="4"
                  :value="phoneNumber.front"
                  @input="frontFormatInput"
                  required
                />
                <input
                  class="input"
                  type="text"
                  maxlength="4"
                  :value="phoneNumber.back"
                  @input="backFormatInput"
                  required
                />
              </div>
            </li>
            <li>
              <span class="subTitle">주소</span>
              <div class="inputBox">
                <input
                  type="text"
                  :value="deliveryInformation.zipCode"
                  readonly
                />
                <button class="button54" @click.prevent="execDaumPostcode">주소검색</button>
              </div>
            </li>
            <li class="noTitle">
              <input
                type="text"
                :value="deliveryInformation.address"
                placeholder="주소"
                readonly
              />
            </li>
            <li class="noTitle">
              <input
                ref="detailAddress"
                type="text"
                v-model="deliveryInformation.detailAddress"
                placeholder="상세주소를 입력하세요"
              />
            </li>
          </ul>
          <div class="buttonWrap">
            <button class="button52" @click.prevent="$emit('showLayer', false)">취소</button>
            <button class="button11" @click.prevent="doneAddress">확인</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</transition>
</template>

<script>
// 'iframe을 이용하여 레이어 띄우기' https://postcode.map.daum.net/guide
import CustomSelectBox from "@/views/base/FormDropdown.vue";
import { mapActions } from 'vuex'
import { beforeSendLog } from '@/utils'

export default {
  name: 'PostAddress',
  components: {
    CustomSelectBox,
  },
  data() {
    return {
      serviceProvider: [
        "010","011","016","017","018","019"
      ],
      phoneNumber: {
        provider: 0,
        front: "",
        back: ""
      },
      deliveryInformation: {
        zipCode: "",
        address: "",
        detailAddress: "",
        receiverName: "",
        phoneNumber: "",
      },
      isShow: false,
    }
  },
  methods: {
    ...mapActions('my', ['openModal']),
    ...mapActions('modal', ['openModal']),
    execDaumPostcode() {
      this.isShow = true;
      const element_wrap = document.getElementById('wrap');
      const currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
      new daum.Postcode({
        oncomplete: (data) => {
          let addr = '';      // 주소 변수
          let extraAddr = ''; // 참고항목 변수

          if (data.userSelectedType === 'R') {
            // 사용자가 도로명 주소를 선택했을 경우
            addr = data.roadAddress;
          } else {
            // 사용자가 지번 주소를 선택했을 경우(J)
            addr = data.jibunAddress;
          }

          // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
          if(data.userSelectedType === 'R'){
            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
            if(data.bname !== '' && /[동|로|가]$/g.test(data.bname)){
              extraAddr += data.bname;
            }
            // 건물명이 있고, 공동주택일 경우 추가한다.
            if(data.buildingName !== '' && data.apartment === 'Y'){
              extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
            }
            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
            if(extraAddr !== ''){
              extraAddr = ' (' + extraAddr + ')';
            }
            // 조합된 참고항목을 해당 필드에 넣는다.
            this.deliveryInformation.extraAddress = extraAddr;
          } else {
            this.deliveryInformation.extraAddress = '';
          }

          // 우편번호와 주소 정보를 해당 필드에 넣는다.
          this.deliveryInformation.zipCode = data.zonecode;
          this.deliveryInformation.address = addr;

          // 커서를 상세주소 필드로 이동한다.
          this.$refs.detailAddress.focus();

          // iframe을 넣은 element를 안보이게 한다.
          // (autoClose:false 기능을 이용한다면, 아래 코드를 제거해야 화면에서 사라지지 않는다.)
          element_wrap.style.display = 'none';
          // 우편번호 찾기 화면이 보이기 이전으로 scroll 위치를 되돌린다.
          document.body.scrollTop = currentScroll;
          this.isShow = false;
        },
        // 우편번호 찾기 화면 크기가 조정되었을때 실행할 코드를 작성하는 부분. iframe을 넣은 element의 높이값을 조정한다.
        onresize : function(size) {
          // element_wrap.style.height = size.height+100+'px';
          element_wrap.style.height = '544px';
        },
        width : '100%',
        height : '90%'
      }).embed(element_wrap);

      // iframe을 넣은 element를 보이게 한다.
      element_wrap.style.display = 'block';
    },
    doneAddress() {
      let message = ''

      if (!this.deliveryInformation.receiverName.length > 0) {
        message = '받는 사람 이름을 입력해주세요.';
      } else if (!this.phoneNumber.front || !this.phoneNumber.back) {
        message = '휴대폰 번호를 입력해주세요.';
      } else if (!this.deliveryInformation.address) {
        message = '주소를 입력해주세요.';
      } else if (!this.deliveryInformation.detailAddress) {
        message = '상세 주소를 입력해주세요.';
      }

      if (message.length > 0) {
        return this.openModal({
          type: 'alert',
          message
        })
      } else {
        const phoneNum = `${this.serviceProvider[this.phoneNumber.provider]}-${this.phoneNumber.front}-${this.phoneNumber.back}`
        const info = {
          ...this.deliveryInformation,
          phoneNumber: phoneNum
        }

        beforeSendLog('Address')
        this.$emit('changeDeliveryInformation', info);
        this.$emit('showLayer', false);
      }
    },
    nameFormatInput(event) {
      if(event.target.value.length <= 10) {
        this.deliveryInformation.receiverName = event.target.value;
      } else {
        this.$forceUpdate();
      }
    },
    frontFormatInput(event) {
      const oldValue = this.phoneNumber.front;
      const newValue = this.replaceText(event.target.value);

      this.phoneNumber.front = newValue;

      if(oldValue === newValue) {
        this.$forceUpdate();
      }
    },
    backFormatInput(event) {
      const oldValue = this.phoneNumber.back;
      const newValue = this.replaceText(event.target.value);

      this.phoneNumber.back = newValue;

      if(oldValue === newValue) {
        this.$forceUpdate();
      }
    },
    replaceText(oldValue) {
      return oldValue.replace(/[^0-9]/g, '');
    },
  },
}
</script>

<style lang="scss">
  // haelim: - 주소검색 카카오 모달 스타일 override
  #wrap{
    display:none;
    position:absolute;
    top:0;
    right:0;
    left:0;
    bottom:0;
    z-index: 999;
    width:330px;
    margin:0 auto;
    background-color: #fff;
    padding: 0 15px;
    .title {
      padding: 15px;
      border-bottom: 1px solid #d6d6db;
      background-color: #fff;
      position: relative;

      h1 {
        margin: 0 auto;
        text-align: center;
        font-size: 16px;
      }
      button {
        position: absolute;
        right: 0;
        top: 15px;
      }
    }
    .popup_foot {
      display: none !important;
      opacity: 0;
    }
    .info_body {
      padding: 20px 0 !important;
    }
  }
</style>
